KXL.module('LegalApp', function (LegalApp, KXL, Backbone, Marionette, $, _) {
	LegalApp.Router = Marionette.AppRouter.extend({
		appRoutes: {
            'tos': 'showTOS',
			'help/tos': 'showTOS',
			'privacypolicy': 'showPrivacyPolicy',
			'help/privacypolicy': 'showPrivacyPolicy',
			'cookiepolicy': 'showCookiePolicy',
			'help/cookiepolicy': 'showCookiePolicy',
			'caprivacyrights': 'showCaPrivacyRights',
			'help/caprivacyrights': 'showCaPrivacyRights'
        }
    });

    const API = Marionette.Controller.extend({
		showTOS: function () {
			window.open(KXL.config.LEGAL_URL);
            KXL.execute('home:show');
		},
		showPrivacyPolicy: function () {
			showTOS();
		},
		showCookiePolicy: function () {
			showTOS();
		},
		showCaPrivacyRights: function() {
			showTOS();
		}
    });

	const legalAPI = new API();

    KXL.addInitializer(function () {
		new LegalApp.Router({
			controller: legalAPI
		});

		KXL.commands.setHandlers({
			'show:TOS': function (options) {
				legalAPI.showTOS(options);
			}
        });
    });
});
